import React, { useState } from "react";
import style from "./Input.module.css";

export default function Input(props) {
  const { password, handlePasswordChange } = props;
  const [show, setShow] = useState(false);
  const handleState = () => {
    setShow(!show);
  };
  return (
    <div className={style.divInput}>
      <label className={style.passLabel} htmlFor="password">
        رمز ورود
      </label>
      <input
        className={style.passInput}
        type={show ? "text" : "password"}
        id="password"
        value={password}
        onChange={handlePasswordChange}
      />
      {show ? (
        <img
          alt="visible"
          onClick={handleState}
          className={style.iconPass}
          src="https://img.icons8.com/material/24/ffffff/visible.png"
        />
      ) : (
        <img
          alt="hide"
          onClick={handleState}
          className={style.iconPass}
          src="https://img.icons8.com/material/24/ffffff/hide--v1.png"
        />
      )}
    </div>
  );
}
